import axios from "axios";

export default {
	listGrades() {
		return axios.get("/v3/grades");
	}
};



// WEBPACK FOOTER //
// ./src/services/GradeService.js